<template>
    <v-timeline
      align-top
      dense
    >
      <Update v-for="(item, i) in updates" :key="'update-item-'+i" :item="item" :payment_methods="payment_methods" :statuses="statuses" />
    </v-timeline>
</template>

<script>
import Update from './Update.vue'
export default {
  components: {
    Update,
	},
  props:['updates', 'payment_methods', 'statuses'],
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
  },

}
</script>

<style>

</style>